// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_he-0";
export var fulfillmentPanelBody = "_he-1";